import * as Sentry from "@sentry/angular";

// Note: 401s from the API are handled globally by SessionExpiredInterceptor,
// which clears a stored session the server no longer accepts.
export class ErrorHandlerService {

  public handleError(error: any): any {
    Sentry.captureException(error.message);

    return error;
  }
}